<template>
  <ul>
    <li v-for="(item, itemIdx) in items" :key="itemIdx" :class="{ 'disabled': revalStatus === 'RequiresRevalidation' && item.stringId !== 'ml_104218', 'ap-menu-collapsed': item.childItems.length }">
      <a :href="item.link" :target="item.target">{{ $t(item.stringId) }}</a>
      <ul v-if="item.childItems.length">
        <li
          v-for="(childItem, childItemIdx) in item.childItems"
          :key="childItemIdx"
          :class="{ 'disabled': revalStatus === 'RequiresRevalidation' && childItem.stringId !== 'ml_104220' }"
        >
          <a :href="childItem.link" :target="childItem.target">{{ $t(childItem.stringId) }}</a>
        </li>
      </ul>
    </li>
    <li>
      <a href="signout">{{ $t('ml_104225') }}</a>
    </li>
  </ul>
</template>

<style>
.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>

<script>
export default {
  name: 'LeftNav',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    revalStatus: {
      type: String,
      default: () => ''
    }
  }
}
</script>
